/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabHistory from './diaglab-history';
import DiaglabHistoryDetail from './diaglab-history-detail';
import DiaglabHistoryUpdate from './diaglab-history-update';
import DiaglabHistoryDeleteDialog from './diaglab-history-delete-dialog';

const DiaglabHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabHistory />} />
    <Route path="new" element={<DiaglabHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabHistoryDetail />} />
      <Route path="edit" element={<DiaglabHistoryUpdate />} />
      <Route path="delete" element={<DiaglabHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabHistoryRoutes;
